var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",style:([_vm.elementStyles, _vm.basicContentStyles]),attrs:{"data-x":_vm.data.position ? _vm.data.position.left : 0,"data-y":_vm.data.position ? _vm.data.position.top : 0}})
}
var staticRenderFns = []

export { render, staticRenderFns }